import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

// Higher resolution map data (50m instead of 110m for more detail)
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-50m.json";

// European countries with ISO 3166-1 numeric codes
const EUROPEAN_COUNTRIES = [
    { code: "008", name: "Albania" },
    { code: "020", name: "Andorra" },
    { code: "040", name: "Austria" },
    { code: "112", name: "Belarus" },
    { code: "056", name: "Belgium" },
    { code: "070", name: "Bosnia and Herzegovina" },
    { code: "100", name: "Bulgaria" },
    { code: "191", name: "Croatia" },
    { code: "196", name: "Cyprus" },
    { code: "203", name: "Czech Republic" },
    { code: "208", name: "Denmark" },
    { code: "233", name: "Estonia" },
    { code: "246", name: "Finland" },
    { code: "250", name: "France" },
    { code: "276", name: "Germany" },
    { code: "300", name: "Greece" },
    { code: "348", name: "Hungary" },
    { code: "352", name: "Iceland" },
    { code: "372", name: "Ireland" },
    { code: "380", name: "Italy" },
    { code: "428", name: "Latvia" },
    { code: "438", name: "Liechtenstein" },
    { code: "440", name: "Lithuania" },
    { code: "442", name: "Luxembourg" },
    { code: "470", name: "Malta" },
    { code: "498", name: "Moldova" },
    { code: "492", name: "Monaco" },
    { code: "499", name: "Montenegro" },
    { code: "528", name: "Netherlands" },
    { code: "807", name: "North Macedonia" },
    { code: "578", name: "Norway" },
    { code: "616", name: "Poland" },
    { code: "620", name: "Portugal" },
    { code: "642", name: "Romania" },
    { code: "674", name: "San Marino" },
    { code: "688", name: "Serbia" },
    { code: "703", name: "Slovakia" },
    { code: "705", name: "Slovenia" },
    { code: "724", name: "Spain" },
    { code: "752", name: "Sweden" },
    { code: "756", name: "Switzerland" },
    { code: "804", name: "Ukraine" },
    { code: "826", name: "United Kingdom" },
    { code: "336", name: "Vatican City" }
].sort((a, b) => a.name.localeCompare(b.name));

const EUROPEAN_CODES = EUROPEAN_COUNTRIES.map(c => c.code);

const EuropeMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{
                scale: 500,
                center: [15, 57]
            }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => EUROPEAN_CODES.includes(geo.id))
                        .map((geo) => {
                            const countryCode = geo.id;
                            const isVisited = visited.includes(countryCode);

                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(countryCode)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="europe"
            analyticsLocationType="european_country"
            trackingLabel="Europe Map"
            storageKey="europe_map"
            title="🇪🇺 Europe Travel Map"
            subtitle="Click on countries you've visited, or use the checklist below!"
            items={EUROPEAN_COUNTRIES.map(c => ({ id: c.code, name: c.name }))}
            noun="Countries"
            unitLabel="countries"
            captionUnit="European countries"
            share={{
                region: 'Europe',
                fileName: 'visited-europe-map.png',
                trackId: 'europe'
            }}
            renderMap={renderMap}
        />
    );
};

export default EuropeMapSection;
